import React, { FC } from "react";
import AdviceWrapper from "./AdviceWrapper";
const App: FC = () => {
	return (
		<div
			className="w-screen h-screen bg-DarkBlue text-white
    font-Manrope flex items-center justify-center"
		>
			<AdviceWrapper />
		</div>
	);
};

export default App;
